import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import "../StatementOfAccount/statementOfAccount.css";
import { faFileInvoice, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Form , Spinner } from "react-bootstrap";
import RegisterTextbox from "../../components/RegisterTextBox";
import CustomButton from "../../components/CustomButton";
import RegisterSelect from "../../components/RegisterSelect";
import UploadInput from "../../components/UploadInput";
import '../AssociationMembers/associationMembers.css'
import "../AddNewClient/addnewclient.css";
import { useState, useEffect } from "react";
import API from "../../api/axiosConfig";
import { useNavigate, useParams } from "react-router";


function EditAddMinutes() {

    const [date, setDate] = useState(new Date().toISOString().substr(0, 10));
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(true);
    const [file, setFile] = useState('');
    const navigate = useNavigate();
    const [isSubmitting, setSubmitting] = useState(false);
    const getMinutes = async () => {
        try {
            const res = await API.get(`/minutesheets/${id}`);
            const data = await res;
            if (data.status === 200) {
                setRows(data.data);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setError(error.response.data.errors);
        }
    };
    useEffect(() => {
        getMinutes();
    }, []);
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        const formData = new FormData();
        formData.append("title", rows.title);
        formData.append("date", rows.date);
        formData.append("note", rows.note);
        formData.append("paper", file);
        formData.append("id", id);
        try {
            API.post("/minutesheets/update", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                if (res.status === 200) {
                    navigate("/addMinutesReport");
                }
            });
        } catch (error) {
            console.error(error);
            setSubmitting(false);
            setError(error.response.data.errors);
        }
    };

    const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
  const [day, month, year] = dateStr.split("-");
  if (!day || !month || !year) return "";
  return `${year}-${month}-${day}`; // yyyy-MM-dd
};

    return (
        <>
            <div className="statementofaccount">
                <Title title="تعديل محضر" className="marketingtitle" icon={<FontAwesomeIcon icon={faFileInvoice} />} />
                <Form className="statementofaccountForm" onSubmit={handleSubmit}>
                    <div className="addClientsInputs">

                        <RegisterTextbox
                            parentStyle={{ width: "45%" }}
                            id="address"
                            label="عنوان المحضر"
                            type="text"
                            stylee={{ width: "45%" }}
                            value={rows.title || ""}
                            onChange={(e) => setRows({ ...rows, title: e.target.value })}
                        />
                        <div style={{ width: "45%", marginBottom: "13px" }}>
                            <label style={{ marginBottom: "10px" }}>تاريخ المحضر</label>
                            <input
                                type="date"
                                id="date"
                                className="custom-datepicker"
                                onChange={(e) => setRows({ ...rows, date: e.target.value })}
                                value={formatDateForInput(rows.date)}
                            />
                        </div>
                    </div>

                    <div className='AddBeneficiaryContainer addClientsInputs5' style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" , width: "100%"}}>

                        <RegisterTextbox
                            parentStyle={{ width: "45%" }}
                            id="notes"
                            label="ملاحظات"
                            type="text"
                            stylee={{ width: "45%" }}
                            value={rows.note || ""}
                            onChange={(e) => setRows({ ...rows, note: e.target.value })}
                        />
                        <UploadInput
                            id="paper"
                            parentStyle={{
                               width: "45%",
                                display: "flex",
                                flexDirection: "row-reverse",
                                alignItems: "center",
                                justifyContent: "center"

                            }}
                            label="إرفاق المستندات "
                            onChange={(e) => setFile(e.target.files[0])}
                        />
                    </div>



                      { 
                    isSubmitting ? <Spinner animation="border" /> :
                    <CustomButton
                        text="حفظ"
                        onClick={handleSubmit}
                        className="addClientBtn"
                    />}
                </Form>
            </div>
        </>
    )
}

export default EditAddMinutes